import {
  type ExpressionObj,
  type PropertiesConfigInputVisibilityModel,
} from '@blaze-shared/elements-domain';
import { type SelectOptionWithImage } from '@blaze-shared/shared-util';

export type TabsTemplate = 'line' | 'box' | 'header' | 'bubble';
export type TabSize = 'hug' | 'fill' | 'fixed';
export type TabIconPosition = 'left' | 'top';

export const MIN_FIXED_TAB_WIDTH = 50;
export const MAX_FIXED_TAB_WIDTH = 400;

export const ICONS_TABS_TEMPLATE_MAP: Record<TabsTemplate, string> = {
  line: 'tt-tabs-line',
  box: 'tt-tabs-box',
  header: 'tt-tabs-header',
  bubble: 'tt-tabs-bubble',
};

export const TABS_TEMPLATE_OPTIONS: SelectOptionWithImage<TabsTemplate, string>[] = [
  { label: 'Line', value: 'line', image: ICONS_TABS_TEMPLATE_MAP['line'] },
  { label: 'Box', value: 'box', image: ICONS_TABS_TEMPLATE_MAP['box'] },
  { label: 'Header', value: 'header', image: ICONS_TABS_TEMPLATE_MAP['header'] },
  { label: 'Bubble', value: 'bubble', image: ICONS_TABS_TEMPLATE_MAP['bubble'] },
];

export interface TabItem {
  /** Used to count the tabs */
  id: number;
  label: string;
  icon?: string;
  visible?: PropertiesConfigInputVisibilityModel;
  visibilityExpression?: ExpressionObj[];
}
